__turbopack_context__.v({
  "modal": "ProductDetailsModal-module-scss-module__zQ3THG__modal",
  "modalBody": "ProductDetailsModal-module-scss-module__zQ3THG__modalBody",
});
